module.exports = __webpack_public_path__ + "static/img/appli-btn.46b2b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/appli-btn.png
// module id = 4U85
// module chunks = 1